import { render, staticRenderFns } from "./MenuTabModifiers.vue?vue&type=template&id=81494e92&scoped=true"
import script from "./MenuTabModifiers.vue?vue&type=script&lang=js"
export * from "./MenuTabModifiers.vue?vue&type=script&lang=js"
import style0 from "./MenuTabModifiers.vue?vue&type=style&index=0&id=81494e92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81494e92",
  null
  
)

export default component.exports